import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ValidityContext } from '../../../../provider/ValidityProvider';
import {
  defaultBlurValidityStatusForm,
  defaultValidityStatusForm,
} from '../../../../store/validity/utils';
import ColorPalette from '../../../ColorPalette';

export default function FormStatusUpdate() {
  const {
    statuses,
    validateForm,
    getFormMessage,
    getValidity,
    setValidity,
    enqueueSnackbar,
    updateValidityStatus,
    filterValidityStatus,
    setModal,
  } = useContext(ValidityContext)!.controllers.status;

  const form = getValidity(`forms.status.update`);

  const blurField = (field: keyof ValidityStatusForm) => () => {
    setValidity(`blur.status.update.${field}`, true);
  };

  const messages = getFormMessage('status.update');

  const clearForm = () => {
    const statusForm = defaultValidityStatusForm();
    setValidity(`forms.status.update`, { id: '', ...statusForm });
    setValidity(`blur.status.update`, defaultBlurValidityStatusForm());
  };

  const [createLoading, setCreateLoading] = useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setCreateLoading(true);
    validateForm('status.update')
      .then(() => {
        updateValidityStatus()
          .then((status) => {
            setValidity(
              `filters.status.data.data`,
              statuses.map((s) => (s.id === status.id ? status : s)),
            );
            clearForm();
            setModal('single.updateStatus', false);
            setTimeout(() => {
              filterValidityStatus();
            }, 1000);
            enqueueSnackbar('Status atualizado com sucesso', {
              variant: 'success',
            });
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao atualizar o status', {
              variant: 'error',
            });
          })
          .finally(() => {
            setCreateLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
        setCreateLoading(false);
      });
  };
  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={form.name}
            onChange={(e) => {
              setValidity('forms.status.update.name', e.target.value);
            }}
            error={messages.name}
            onBlur={blurField('name')}
          />
          <ColorPalette
            value={form.color}
            onChange={(color) => {
              setValidity('forms.status.update.color', color);
            }}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={createLoading}>Atualizar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
